<template>
  <div class="text-gray-900 font-sans py-12 p-4 sm:p-6">
    <div class="max-w-4xl mx-auto space-y-10">

      <!-- Carte de prestations sélectionnées -->
      <section class="mb-10" v-if="selectedServices.length">
        <h2 class="text-base sm:text-lg font-semibold mb-2">
          <span class="text-indigo-600">1.</span> Prestation sélectionnée
        </h2>
        <div class="space-y-4">
          <div
            v-for="(service, index) in selectedServices"
            :key="index"
            class="bg-white rounded-xl shadow-md p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0"
          >
            <div class="text-sm text-gray-800 leading-tight max-w-full sm:max-w-[70%]">
              <p class="font-semibold mb-1">{{ service.name }} - {{ service.price }}€</p>
              <p class="text-gray-600 flex flex-wrap items-center gap-1">
                <span>{{ service.duration }}</span>
                <span class="text-gray-400">•</span>
                <span class="font-semibold">{{ service.price }} €</span>
              </p>
            </div>
            <button @click="removeService(index)" class="text-indigo-600 text-sm underline whitespace-nowrap">
              Supprimer
            </button>
          </div>
        </div>
        <button
          type="button"
          class="mt-6 inline-flex items-center gap-2 bg-gray-900 text-white text-sm font-normal rounded-md px-4 py-2 hover:bg-gray-800 transition"
          @click="showPrestationList = true"
        >
          <i class="fas fa-plus"></i> Ajouter une prestation à la suite
        </button>
      </section>

      <!-- Tabs -->
      <section v-if="showPrestationList">
        <p class="text-base text-left mb-2">
          <a href="#" class="text-blue-600">1.</a> Choix de la prestation
        </p>

        <!-- Onglets de catégories -->
        <div class="flex overflow-x-auto space-x-4 mb-6">
          <button
            v-for="(category, index) in categories"
            :key="index"
            @click="activeCategory = category"
            :class="[
              'px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition',
              activeCategory === category
                ? 'bg-blue-900 text-white'
                : 'text-left text-gray-700'
            ]"
          >
            {{ category }}
          </button>
        </div>

        <!-- Prestations filtrées -->
        <h3 class="text-base sm:text-lg font-semibold mb-4 text-left">{{ activeCategory }}</h3>
        <div class="bg-white rounded-lg shadow divide-y divide-gray-200">
          <div
            v-for="(service, index) in filteredServices"
            :key="index"
            class="p-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-4"
          >
            <div class="text-left flex-1 pr-0 md:pr-6">
              <p class="text-sm font-semibold mb-1">{{ service.name }} - {{ service.duration }}</p>
              <p class="text-gray-600 text-sm leading-relaxed mb-1">{{ service.description }}</p>
              <button
                class="text-xs text-gray-600 flex items-center space-x-1 mb-2"
                @click="toggleDetails(service)"
              >
                <span>Plus de détails</span>
                <svg class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div v-if="service.showDetails" class="text-gray-600 text-xs">
                <p>{{ service.details }}</p>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row gap-2 items-start sm:items-end justify-start sm:justify-center text-sm text-gray-700 font-semibold min-w-[140px]">
              <div class="flex gap-1 items-center">
                <span>{{ service.duration }}</span>
                <span>•</span>
                <span>{{ service.price }} €</span>
              </div>
              <button
                class="bg-[#cd825b] text-white rounded-md px-4 py-2 text-sm font-medium hover:bg-gray-800"
                @click="addService(service)"
              >
                Choisir
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- Étape de sélection horaire -->
      <section v-if="selectedServices.length && !showPrestationList">
      <TimeslotComponents
  :selectedServices="selectedServices"
  @creneau-selectionne="handleCreneauSelectionne"
/>
       <button
  @click="confirmerRdv"
  class="mt-6 w-full bg-indigo-600 text-white font-semibold py-3 rounded-lg hover:bg-indigo-700 transition"
>
  Confirmer le rendez-vous
</button>
      </section>
    </div>
  </div>
</template>

  
<script>
import TimeslotComponents from '@/components/TimeslotComponents.vue';
import axios from 'axios';

export default {
  components: { TimeslotComponents },
  data() {
    return {
      categories: [], // Rempli dynamiquement
      activeCategory: '',
      showPrestationList: true,
      selectedServices: [],
      services: [],
      selectedCreneau: null,
    };
  },
  computed: {
    filteredServices() {
      return this.services.filter(s => s.category === this.activeCategory);
    },
  },
  methods: {
    async loadServicesFromQuery() {
  const ids = this.$route.query.replanifier?.split(',') || [];

  if (ids.length === 0) return;

  // On attend que les services soient chargés
  if (this.services.length === 0) {
    await this.fetchCategoriesWithServices(); // S'assurer qu'on les a bien
  }

  // Trouver les services correspondant aux IDs
  const matchedServices = this.services.filter(service => ids.includes(service._id));

  // Ajouter uniquement ceux qui ne sont pas déjà sélectionnés
  this.selectedServices = matchedServices.map(service => ({ ...service }));

  if (this.selectedServices.length > 0) {
    this.showPrestationList = false;
  }
},
async confirmerRdv() {
  if (!this.selectedCreneau) {
    alert("Veuillez sélectionner un créneau avant de confirmer.");
    return;
  }
  if (this.selectedServices.length === 0) {
    alert("Veuillez sélectionner au moins un service.");
    return;
  }

  const firmId = '6825f7fa29a0ebecdccaccf3'; // À rendre dynamique si possible
  const employeId = this.selectedCreneau.employeId;
  const serviceIds = this.selectedServices.map(s => s._id);
  const date = this.selectedCreneau.date; // 'YYYY-MM-DD'
  const heureDebut = this.selectedCreneau.slot; // 'HH:mm'
  const token = localStorage.getItem('clientToken'); // Authentification requise
  const bookingId = this.$route.query.bookingId;

  const payload = {
    employeId,
    serviceIds,
    date,
    heureDebut
  };

  try {
    const headers = {
      Authorization: `Bearer ${token}`
    };

    if (this.$route.query.replanifier && bookingId) {
      // Mode replanification
      const response = await axios.put(`http://localhost:3000/api/appointment/replanifier/${bookingId}`, payload, { headers });
      alert("Rendez-vous replanifié !");
      console.log(response.data);
    } else {
      // Mode prise de RDV normal
      const clientId = localStorage.getItem('USERID'); // Authentification côté client
      const response = await axios.post('http://localhost:3000/api/appointment/prendre', {
        ...payload,
        firmId,
        clientId
      });
      alert("Rendez-vous confirmé !");
      console.log(response.data);
    }

    // Optionnel : redirection
    // this.$router.push('/mes-rendez-vous');

  } catch (error) {
    console.error("❌ Erreur :", error.response?.data || error.message);
    alert("Erreur : " + (error.response?.data?.message || error.message));
  }
},
     handleCreneauSelectionne({ date, slot, employeId }) {
    console.log("Créneau sélectionné :", {
      date,
      slot,
      employeId,
    });

    // Tu peux stocker ça dans une data si besoin :
    this.selectedCreneau = { date, slot, employeId };
  },
    toggleDetails(service) {
      service.showDetails = !service.showDetails;
    },
    addService(service) {
      this.selectedServices.push({ ...service });
      this.showPrestationList = false;
    },
    removeService(index) {
      this.selectedServices.splice(index, 1);
      if (this.selectedServices.length === 0) {
        this.showPrestationList = true;
      }
    },
    async fetchCategoriesWithServices() {
      try {
        const res = await axios.get('http://localhost:3000/api/categorie/with-services');
        const data = res.data;

        // Extraire noms des catégories et transformer les services
        this.categories = data.map(cat => cat.nom.toUpperCase());
        this.activeCategory = this.categories[0] || '';

        // Formater les services
        this.services = data.flatMap(cat =>
          cat.services.map(service => ({
            _id: service._id, // <-- ceci est essentiel
            category: cat.nom.toUpperCase(),
            name: service.nom,
            duration: `${service.duree} min`,
            description: service.description,
            details: service.description,
            price: service.prix,
            showDetails: false,
          }))
        );
      } catch (error) {
        console.error('Erreur lors du chargement des catégories avec services:', error);
      }
    },
  },
  mounted() {
    this.fetchCategoriesWithServices().then(() => {
    this.loadServicesFromQuery();
  });
    
  },
};
</script>

  